@if (loadedAnyData) {
  <fl-workspace [workspaceType]="workspaceType" (setWorkspaceType)="onSetWorkspaceType($event)"></fl-workspace>
  <fl-sidebar [editorWorkspaceType]="workspaceType"></fl-sidebar>
}
